import React from 'react';
import LoadingImage from '../../assets/images/logogif.gif';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
const Loading = () => {
  return (
    <div style={{ width: "100%", height: "70vh", display: 'flex', alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
      {/* <img src={LoadingImage} width={300} style={{borderRadius:"50%"}} alt="Loading..." /> */}
       <div
                          style={{
                              width: '100vw',
                              height: '100vh',
                              display: 'flex',
                              justifyContent: 'center',
                              position: 'absolute',
                              alignItems: 'center'
                          }}
                          className="loading-One"
                      >
                          <Box
                              sx={{
                                  position: 'relative',
                                  zIndex: 2,
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  height: '100%', // or specific height if needed
                              }}
                          >
                              <CircularProgress size={40} color="primary" />
                          </Box>
                      </div>
      {/* <h4>Loading...</h4> */}
    </div>
  )
}

export default Loading;